import { SITE_URL } from './routeMeta';

const ORG_ID = `${SITE_URL}/#organization`;

/**
 * schema.org graph for the homepage: who we are, the site, and the product with its "from" price.
 *
 * @param {{ lowPrice: number, description: string }} input
 * @returns {object}
 */
export function buildHomeStructuredData({ lowPrice, description }) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      { '@type': 'Organization', '@id': ORG_ID, name: 'Handfastly', url: SITE_URL, logo: `${SITE_URL}/icon-512.png` },
      { '@type': 'WebSite', name: 'Handfastly', url: SITE_URL, publisher: { '@id': ORG_ID } },
      {
        '@type': 'SoftwareApplication',
        name: 'Handfastly',
        url: SITE_URL,
        applicationCategory: 'LifestyleApplication',
        operatingSystem: 'Web',
        description,
        publisher: { '@id': ORG_ID },
        offers: { '@type': 'AggregateOffer', lowPrice: String(lowPrice), priceCurrency: 'USD' },
      },
    ],
  };
}

const SCRIPT_ID = 'ld-home';

/** Adds the JSON-LD block, or removes it when `data` is null. */
export function applyStructuredData(data) {
  let el = document.getElementById(SCRIPT_ID);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = SCRIPT_ID;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}
